import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../Button";

const Model = ({ isOpen, onClose, children, name }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 ">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 30,
              duration: 0.5,
            }}
            className="w-full max-w-3xl max-h-[90vh] bg-white rounded shadow-xl overflow-hidden"
          >
            <div className="sticky top-0 z-10 bg-primary px-6 py-4 flex justify-between items-center border-b border-gray-200">
              <h2 className="text-xl font-semibold text-white uppercase">
                {name}
              </h2>
              <Button
                icon={IoClose}
                onClick={onClose}
                className="text-white text-2xl transition"
              ></Button>
            </div>

            <div className="overflow-y-auto max-h-[70vh] px-6 py-5">
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Model;
